// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compat (desktop) */

@media (width >= /* \$screen-sm */ 426px) {
  .bc-table {
    /* Expand all columns. */
    grid-template-columns: minmax(20vw, min-content) repeat(
        var(--compat-browser-count),
        auto
      );

    thead {
      display: contents;

      .bc-platforms {
        th {
          vertical-align: revert;
        }
      }
    }

    tbody {
      --compat-border: 1px solid var(--compat-border-secondary);

      /* Border. */
      tr {
        &:not(:first-child) {
          th,
          td {
            > * {
              border-top: var(--compat-border);
            }
          }

          .bc-feature {
            border-top: var(--compat-border);
          }
        }

        th:not(:first-child),
        td:not(:first-child) {
          > * {
            border-left: var(--compat-border);
          }
        }
      }
    }

    td,
    th {
      padding: 0.25rem;
      background: inherit;
    }

    td.bc-support {
      padding: 0;

      > button {
        padding: 0.25rem;
      }
    }

    .timeline {
      border-top: var(--compat-border);
      border-left: none !important;
    }

    .bc-has-history:focus-within > button {
      /* Highlight expanded item. */
      --padding-bottom-offset: -2px;
      border-bottom: 2px solid var(--compat-text-primary);
    }
  }

  .table-container {
    width: 100vw;
    margin: 0 -3rem;
    overflow: auto;
  }

  .table-container-inner {
    position: relative;
    min-width: max-content;
    padding: 0 3rem;

    &::after {
      position: absolute;
      right: 0;
      bottom: 0;

      width: 10px;
      height: 10px;

      content: "";
    }
  }

  .bcd-cell-text-wrapper {
    .bc-support-level,
    .bc-browser-name {
      display: none;
    }
  }

  .bc-notes-list {
    width: auto;
    max-width: 80vw;
    margin-left: 20%;
  }

  .bc-support {
    .bc-support-level {
      display: none;
    }
  }

  .bc-has-history {
    cursor: pointer;

    > button:hover {
      background: var(--compat-background-secondary);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./components/compat/index-desktop.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE;IACE,wBAAwB;IACxB;;;OAGG;;IAEH;MACE,iBAAiB;;MAEjB;QACE;UACE,sBAAsB;QACxB;MACF;IACF;;IAEA;MACE,yDAAyD;;MAEzD,YAAY;MACZ;QACE;UACE;;YAEE;cACE,gCAAgC;YAClC;UACF;;UAEA;YACE,gCAAgC;UAClC;QACF;;QAEA;;UAEE;YACE,iCAAiC;UACnC;QACF;MACF;IACF;;IAEA;;MAEE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,UAAU;;MAEV;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,gCAAgC;MAChC,4BAA4B;IAC9B;;IAEA;MACE,6BAA6B;MAC7B,6BAA6B;MAC7B,mDAAmD;IACrD;EACF;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;;IAEf;MACE,kBAAkB;MAClB,QAAQ;MACR,SAAS;;MAET,WAAW;MACX,YAAY;;MAEZ,WAAW;IACb;EACF;;EAEA;IACE;;MAEE,aAAa;IACf;EACF;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,eAAe;;IAEf;MACE,8CAA8C;IAChD;EACF;AACF","sourcesContent":["/* Compat (desktop) */\n\n@media (width >= /* $screen-sm */ 426px) {\n  .bc-table {\n    /* Expand all columns. */\n    grid-template-columns: minmax(20vw, min-content) repeat(\n        var(--compat-browser-count),\n        auto\n      );\n\n    thead {\n      display: contents;\n\n      .bc-platforms {\n        th {\n          vertical-align: revert;\n        }\n      }\n    }\n\n    tbody {\n      --compat-border: 1px solid var(--compat-border-secondary);\n\n      /* Border. */\n      tr {\n        &:not(:first-child) {\n          th,\n          td {\n            > * {\n              border-top: var(--compat-border);\n            }\n          }\n\n          .bc-feature {\n            border-top: var(--compat-border);\n          }\n        }\n\n        th:not(:first-child),\n        td:not(:first-child) {\n          > * {\n            border-left: var(--compat-border);\n          }\n        }\n      }\n    }\n\n    td,\n    th {\n      padding: 0.25rem;\n      background: inherit;\n    }\n\n    td.bc-support {\n      padding: 0;\n\n      > button {\n        padding: 0.25rem;\n      }\n    }\n\n    .timeline {\n      border-top: var(--compat-border);\n      border-left: none !important;\n    }\n\n    .bc-has-history:focus-within > button {\n      /* Highlight expanded item. */\n      --padding-bottom-offset: -2px;\n      border-bottom: 2px solid var(--compat-text-primary);\n    }\n  }\n\n  .table-container {\n    width: 100vw;\n    margin: 0 -3rem;\n    overflow: auto;\n  }\n\n  .table-container-inner {\n    position: relative;\n    min-width: max-content;\n    padding: 0 3rem;\n\n    &::after {\n      position: absolute;\n      right: 0;\n      bottom: 0;\n\n      width: 10px;\n      height: 10px;\n\n      content: \"\";\n    }\n  }\n\n  .bcd-cell-text-wrapper {\n    .bc-support-level,\n    .bc-browser-name {\n      display: none;\n    }\n  }\n\n  .bc-notes-list {\n    width: auto;\n    max-width: 80vw;\n    margin-left: 20%;\n  }\n\n  .bc-support {\n    .bc-support-level {\n      display: none;\n    }\n  }\n\n  .bc-has-history {\n    cursor: pointer;\n\n    > button:hover {\n      background: var(--compat-background-secondary);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
